/* RARE FORM — Fullscreen Menu (original feel + safe cursor hover/white) */
(function(){
  const root = document.getElementById('rf-menu');
  if(!root) return;

  // Hoist the menu to <body> so it sits on top of everything (covers announcement bar)
  try{ if(root.parentNode !== document.body) document.body.appendChild(root); }catch(e){}

  const wrap     = root.querySelector('.rf-wrap');
  const img      = root.querySelector('#rf-img');
  const closeBtn = root.querySelector('.rf-close');

  // Dawn/variants hamburger triggers
  const burgerSel = [
    'header-drawer summary',
    '.header__icon--menu',
    'button[aria-controls="menu-drawer"]',
    'button[aria-controls="Details-menu-drawer"]',
    '.menu-drawer__open'
  ].join(',');

  const q  = (s,ctx=document)=>ctx.querySelector(s);
  const qa = (s,ctx=document)=>Array.from(ctx.querySelectorAll(s));

  /* ========= CONFIG: close button fixed offsets ========= */
  const CLOSE_LEFT = 60;  // move right/left (px) from the viewport edge
  const CLOSE_TOP  = 70;  // move down/up  (px) from the viewport edge

  /* ============= Reveal origin from burger (only) ============= */
  function positionFromBurger(){
    const b = document.querySelector(burgerSel);
    if(!b) return;
    const r = b.getBoundingClientRect(); // viewport coords
    const x = r.left + r.width/2;
    const y = r.top  + r.height/2;
    root.style.setProperty('--rf-reveal-x', x + 'px');
    root.style.setProperty('--rf-reveal-y', y + 'px');
  }

  /* ---------------------------
     Cursor: keep above overlay
     --------------------------- */
  function collectCursorNodes(){
    const sel = [
      '[class*="cursor"]','[id*="cursor"]','[data-cursor]',
      '.cursor-wrapper','[class*="cursor-wrap"]',
      '[class*="mouse"]','[id*="mouse"]'
    ].join(',');
    return Array.from(document.querySelectorAll(sel));
  }

  function hoistCursorDeep(){
    collectCursorNodes().forEach(el=>{
      try{
        if (el.parentNode !== document.body) document.body.appendChild(el);
        Object.assign(el.style, {
          position:'fixed', pointerEvents:'none', zIndex:'2147483649',
          opacity:'1', visibility:'visible', mixBlendMode:'normal', filter:'none'
        });
      }catch(_){}
    });
  }
  const mo = new MutationObserver(()=> hoistCursorDeep());
  mo.observe(document.documentElement, { childList:true, subtree:true });

  /* ---------------------------------------
     Enlarge-on-hover: robust, zero conflicts
     --------------------------------------- */
  const INTERACTIVE_SEL = 'a, button, [role="button"], input, textarea, select, .rf-link';
  function updateHoverFromPoint(x, y){
    const el = document.elementFromPoint(x, y);
    const hit = el && (el.closest ? el.closest(INTERACTIVE_SEL) : null);
    document.documentElement.classList.toggle('cursor-hover', !!hit);
  }
  function onPointerMove(e){ updateHoverFromPoint(e.clientX, e.clientY); }

  /* -------------
     Open / Close
     ------------- */
  function openMenu(e){
    e?.preventDefault?.();
    e?.stopPropagation?.();

    // compute reveal origin from the current burger
    positionFromBurger();

    // hard-lock the close button in the top-left (safe-area aware)
    if (closeBtn){
      closeBtn.style.position = 'fixed';
      closeBtn.style.left  = `calc(env(safe-area-inset-left, 0px) + ${CLOSE_LEFT}px)`;
      closeBtn.style.top   = `calc(env(safe-area-inset-top,  0px) + ${CLOSE_TOP}px)`;
      closeBtn.style.right = 'auto';
      closeBtn.style.bottom= 'auto';
    }

    root.classList.remove('closing');
    root.classList.add('is-open');       // black circle starts expanding immediately
    document.body.classList.add('rf-open');
    hoistCursorDeep();                   // keep custom cursor on top immediately
    document.documentElement.classList.remove('cursor-hover');

    // show content slightly after black is visible
    clearTimeout(openMenu._t);
    openMenu._t = setTimeout(()=> root.classList.add('content-in'), 220);

    // start hover tracking while menu is open
    window.addEventListener('pointermove', onPointerMove, { passive:true });
  }

  function closeMenu(){
    // hide content first
    root.classList.remove('content-in');

    // then collapse the circle
    clearTimeout(closeMenu._t1);
    clearTimeout(closeMenu._t2);
    closeMenu._t1 = setTimeout(()=>{
      root.classList.add('closing');     // ::before scales back to the burger
      closeMenu._t2 = setTimeout(()=>{
        root.classList.remove('is-open','closing');
        document.body.classList.remove('rf-open');
        document.documentElement.classList.remove('cursor-hover');
        window.removeEventListener('pointermove', onPointerMove, { passive:true });
      }, 700);                           // match the CSS circle duration
    }, 180);
  }

  function hookBurgers(){
    qa(burgerSel).forEach(btn=>{
      if(btn.dataset.rfHooked) return;
      btn.dataset.rfHooked = '1';
      // capture phase so we beat the theme’s own drawer
      btn.addEventListener('click', openMenu, true);
    });
  }

  function hookPreviews(){
    qa('.rf-link', wrap).forEach(a=>{
      const set = ()=>{
        const src = a.getAttribute('data-image');
        if(src && img && img.src !== src) img.src = src;
      };
      a.addEventListener('mouseenter', set);
      a.addEventListener('focus', set);
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', e=>{ if(e.key === 'Escape') closeMenu(); });

  // keep reveal origin up to date; the X stays fixed
  window.addEventListener('resize', positionFromBurger, {passive:true});
  window.addEventListener('orientationchange', positionFromBurger, {passive:true});
  window.addEventListener('scroll', ()=>{ if (!root.classList.contains('is-open')) positionFromBurger(); }, {passive:true});

  // init
  hookBurgers();
  hookPreviews();
  positionFromBurger();
  document.addEventListener('shopify:section:load', ()=>{ hookBurgers(); hookPreviews(); positionFromBurger(); });

  // console helpers: RFMenu.open() / RFMenu.close()
  window.RFMenu = { open: openMenu, close: closeMenu };
})();
